// src/lib/canonical.ts
//
// Build canonical URLs per stage. On prod we use fhirfly.io; on preview we
// use preview.fhirfly.io; in dev we fall back to the live window.location
// origin at runtime so local developers see something sensible when
// rendering <PageMeta>.

const STAGE = import.meta.env.VITE_STAGE as string | undefined;

function siteOrigin(): string {
  if (STAGE === "prod") return "https://fhirfly.io";
  if (STAGE === "preview") return "https://preview.fhirfly.io";
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://fhirfly.io";
}

/**
 * Build a canonical URL for a given path.
 * @param path - an absolute site path, e.g. "/pricing" or "/blog/my-post"
 */
export function canonicalUrl(path: string): string {
  const origin = siteOrigin();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  // Strip trailing slash except for root.
  const trimmed =
    normalized.length > 1 && normalized.endsWith("/")
      ? normalized.slice(0, -1)
      : normalized;
  return `${origin}${trimmed}`;
}
